export const styles = (theme) => ({
    floatingContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: 2,
    },
    chatPanel: {
        width: 380,
        height: 520,
        maxWidth: 'calc(100vw - 32px)',
        maxHeight: '70vh',
        borderRadius: 16,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.colors.background,
        border: `1px solid ${theme.palette.custom.lightGray}`,
    },
    chatHeader: {
        backgroundColor: theme.palette.custom.brown,
        color: theme.colors.white,
        padding: '25px 14px',
        display: 'grid',
        gridTemplateColumns: '32px 2fr 32px',
        alignItems: 'center',
        gap: 8,
    },
    intentSelector: {
        padding: '10px 14px',
        borderBottom: `1px solid ${theme.palette.custom.lightGray}`,
        backgroundColor: theme.colors.background,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
    },
    intentPrompt: {
        fontSize: '1.1rem',
        color: theme.text.primary,
        fontWeight: 500,
    },
    intentOptions: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1,
    },
    intentButton: {
        textTransform: 'none',
        backgroundColor: theme.palette.custom.lightGray,
        color: theme.text.primary,
        '&:hover': {
            backgroundColor: theme.palette.custom.lightGray,
        },
    },
    intentSelected: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
    },
    intentSelectedLabel: {
        fontSize: '1.1rem',
        fontWeight: 600,
        color: theme.text.primary,
    },
    intentChangeButton: {
        textTransform: 'none',
        fontSize: '0.95rem',
        color: theme.palette.custom.brown,
        border: `1px solid ${theme.palette.custom.brown}`,
        padding: '2px 10px',
        borderRadius: 10,
        '&:hover': {
            borderColor: theme.palette.custom.brown,
            backgroundColor: theme.palette.custom.lightGray,
        },
    },
    headerIconSlot: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    headerCenter: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        textAlign: 'center',
    },
    headerTitle: {
        fontWeight: 600,
        fontSize: '1.5rem',
        color: theme.colors.white,
        lineHeight: 1.2,
        textAlign: 'center',
    },
    headerStatus: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
    },
    statusDot: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: theme.palette.custom.mustard,
    },
    headerSubtitle: {
        fontSize: '1.05rem',
        fontWeight: 500,
        color: theme.colors.white,
        opacity: 0.85,
    },
    headerCloseSlot: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
    closeButton: {
        color: theme.colors.white,
    },
    messagesContainer: {
        flex: 1,
        padding: '10px 14px',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        backgroundColor: theme.colors.lightBackground,
        overflowY: 'auto',
    },
    messageRow: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 1,
    },
    messageRowUser: {
        alignItems: 'flex-end',
    },
    messageBubble: {
        display: 'flex',
        flexDirection: 'column',
        width: 'fit-content',
        maxWidth: '75%',
        padding: '8px 12px',
        borderRadius: 7,
        backgroundColor: theme.palette.custom.lightGray,
        color: theme.text.primary,
        boxShadow: theme.shadows[1],
        alignSelf: 'flex-start',
        wordBreak: 'break-word',
        overflowWrap: 'anywhere',
        gap: '4px',
        '& .MuiTypography-root': {
            color: 'inherit',
            fontSize: '1.2rem',
            whiteSpace: 'pre-wrap',
        },
    },
    messageBubbleUser: {
        backgroundColor: theme.palette.custom.brown,
        color: theme.colors.white,
        alignSelf: 'flex-end',
        '& .MuiTypography-root': {
            color: theme.colors.white,
            fontSize: '1.2rem',
            whiteSpace: 'pre-wrap',
        },
    },
    typingBubble: {
        opacity: 0.75,
        fontStyle: 'italic',
    },
    messageMeta: {
        marginTop: 0,
        fontSize: '1.2rem',
        color: theme.text.light,
        lineHeight: 1.1,
        opacity: 0.8,
    },
    inputContainer: {
        padding: '12px 20px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        borderTop: `1px solid ${theme.palette.custom.lightGray}`,
        backgroundColor: theme.colors.background,
        boxSizing: 'border-box',
    },
    disclaimer: {
        padding: '0 20px 12px',
        fontSize: '1rem',
        lineHeight: 1.2,
        color: theme.text.light,
        opacity: 0.7,
        textAlign: 'center',
        backgroundColor: theme.colors.background,
    },
    inputField: {
        flex: 1,
        minWidth: 0,
        '& .MuiInputBase-root': {
            height: 44,
            borderRadius: 10,
        },
        '& .MuiInputBase-input': {
            padding: '10px 14px',
            fontSize: '1.2rem',
        },
        '& .MuiInputBase-input::placeholder': {
            fontSize: '1.2rem',
            opacity: 0.8,
        },
    },
    sendButton: {
        backgroundColor: theme.palette.custom.mustard,
        color: theme.colors.white,
        width: 44,
        height: 44,
        borderRadius: 12,
        padding: 0,
        '&:hover': {
            backgroundColor: theme.palette.custom.brown,
        },
    },
    sendButtonDisabled: {
        backgroundColor: theme.palette.custom.lightGray,
        color: theme.text.light,
        '&:hover': {
            backgroundColor: theme.palette.custom.lightGray,
        },
    },
    fab: {
        backgroundColor: theme.palette.custom.mustard,
        color: theme.colors.white,
        '&:hover': {
            backgroundColor: theme.palette.custom.brown,
        },
    },
    fabOpen: {
        backgroundColor: theme.palette.custom.brown,
    },
});
